<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>分类管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">分类列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="名称">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入分类名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select v-model="ruleForm.region" placeholder="请选择状态">
                    <el-option label="启用" value="0"></el-option>
                    <el-option label="禁用" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="$router.push('/classifyAdd')"
          >添加</el-button
        >
        <el-table
          :data="tableData"
          style="width: 100%"
          row-key="id"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column prop="categoryNo" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="name" label="分类名称" align="center">
          </el-table-column>
          <!-- <el-table-column label="上级分类" align="center">
            <template slot-scope="scope">
              <span
                v-for="(item, index) in tableData"
                :key="index"
                v-if="scope.row.pid == item.id"
                >{{ item.name }}</span
              >
            </template>
          </el-table-column> -->
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.saleStatus == 0"
                >停用</span
              >
              <span class="greenColor" v-if="scope.row.saleStatus == 1"
                >启用</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn redColor1"
                  @click="edit(scope.row)"
                  v-if="scope.row.saleStatus == 1"
                >
                  禁用
                </div>
                <div
                  class="operateBtn greenColor1"
                  @click="edit(scope.row)"
                  v-if="scope.row.saleStatus == 0"
                >
                  启用
                </div>
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      ruleForm: {
        name: "",
        region: "",
      },
      tableData: [],
      page: 1,
      pageSize: 1000,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.region = "";
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm.name,
        });
      }
      if (this.ruleForm.region != "") {
        param.queryParams.push({
          name: "sale_status",
          type: "select",
          values: [{ itemKey: this.ruleForm.region }],
        });
      }
      this.$axios
        .post(`/admapi/categories/treelist`, param)
        .then(({ data }) => {
          this.tableData = data;
        })
        .catch()
        .finally();
    },
    handleEdit(val1) {
      this.$router.push({
        path: "/classifyAdd",
        query: {
          id: val1.id,
        },
      });
    },
    edit(val) {
      this.$confirm(val.saleStatus == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.saleStatus == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/categories/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.saleStatus == 1 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
